import { createSlice } from "@reduxjs/toolkit";

const wishListSlice = createSlice({
  name: "wishlist",
  initialState: {
    products: [],
    quantity: 0,
    total: 0,
    isFetching: false,
    error: false,
  },
  reducers: {
    addProductToWishStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    addProductToWishSuccess: (state, action) => {
      state.isFetching = false;
      // state.quantity += 1;
      state.products = action.payload;
    },
    addProductToWishFailure: (state, action) => {
      state.isFetching = false;
      state.error = true;
    },
    getWishListStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getWishListSuccess: (state, action) => {
      state.isFetching = false;
      state.products = action.payload;
    },
    getWishListFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    removeProductToWishStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    removeProductToWishSuccess: (state, action) => {
      state.isFetching = true;
      state.products = action.payload;
    },
    removeProductToWishFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },

    removeFromWishList(state, action) {
      console.log("action", action.payload._id);
      state.products.map((cartItem) => {
        console.log("cartItem", cartItem._id);
        console.log("action", action.payload._id);

        if (cartItem._id === action.payload._id) {
          const nextCartItems = state.products.filter(
            (item) => item._id !== action.payload._id
          );
          state.products = nextCartItems;
          state.quantity -= 1;
          state.total -= action.payload.price * action.payload.quantity;
        }
      });
    },
    clearWishList(state, action) {
      state.products = [];
      state.quantity = 0;
      state.total = 0;
    },
  },
});

export const {
  addProductToWishStart,
  addProductToWishSuccess,
  addProductToWishFailure,
  removeProductToWishStart,
  removeProductToWishSuccess,
  removeProductToWishFailure,
  getWishListStart,
  getWishListSuccess,
  getWishListFailure,
  removeFromWishList,
  clearWishList,
} = wishListSlice.actions;
export default wishListSlice.reducer;
